import { CreateReportVoucherRedemptionForm } from './create-voucher-redemption-count-report-form'

export const CreateReportVoucherRedemption = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateReportVoucherRedemptionForm onCloseModal={onCloseModal} />
}
